'use client';

import { useTranslations } from 'next-intl';
import {
  BodyDefault,
  ListPageOptionsMenuItem,
  Menu,
  Spinner,
} from '@terra/ui-design-system';
import { token } from '@terra/ui-styled-system';
import { ArrowRight01Icon } from '@terra/ui-icons';
import { useAssetsCsvExport } from '../../../hooks/api/useAssetsCsvExport';
import type { AssetsSearchRequestFilters } from '../../../hooks/api/assets-search-request';

const CSV_EXPORT_FORMAT = 'csv';

export function AssetsExportMenuRow({
  applicationId,
  filters,
}: {
  applicationId: string | null | undefined;
  filters: AssetsSearchRequestFilters;
}) {
  const t = useTranslations('proxy.assets.export');
  const tCommon = useTranslations('common');
  const { exportAssets, isExporting, canExport } = useAssetsCsvExport({
    applicationId,
    filters,
  });

  return (
    <Menu.MenuWithItems
      positioning={{ strategy: 'fixed', placement: 'right-start' }}
      contentWidth="200px"
      items={[
        {
          value: CSV_EXPORT_FORMAT,
          label: tCommon('exportToCsv'),
          disabled: !canExport || isExporting,
          onClick: () => exportAssets(),
        },
      ]}
      trigger={
        <ListPageOptionsMenuItem disabled={!canExport}>
          <BodyDefault flex="1" textAlign="left">
            {t('label')}
          </BodyDefault>
          {isExporting ? (
            <Spinner size="xs" />
          ) : (
            <ArrowRight01Icon
              size={14}
              color={token('colors.fg.neutral.subtle')}
            />
          )}
        </ListPageOptionsMenuItem>
      }
    />
  );
}
